/**
 * Lightweight diagnostic ring buffer for production debugging.
 * Captures auth events, state changes, and component lifecycle events.
 *
 * Usage in browser console:
 *   window.__dumpDiag()   — formatted string of last 100 events
 *   window.__getDiagEvents() — raw event array
 */

interface DiagEvent {
  ts: number;
  type: string;
  detail: string;
}

const MAX_EVENTS = 100;
const events: DiagEvent[] = [];

export function logDiag(type: string, detail: string) {
  const entry: DiagEvent = { ts: Date.now(), type, detail };
  events.push(entry);
  if (events.length > MAX_EVENTS) events.shift();

  if (import.meta.env.DEV) {
    console.log(`[DIAG] ${type}: ${detail}`);
  }
}

function getDiagEvents(): DiagEvent[] {
  return [...events];
}

function dumpDiag(): string {
  if (events.length === 0) return '(no diagnostic events)';
  return events
    .map(e => `${new Date(e.ts).toISOString()} [${e.type}] ${e.detail}`)
    .join('\n');
}

// Expose globally for production debugging via browser console
if (typeof window !== 'undefined') {
  (window as any).__dumpDiag = dumpDiag;
  (window as any).__getDiagEvents = getDiagEvents;
}
